import { render } from "./salesDeleteConfirmation.vue?vue&type=template&id=b703862c&scoped=true"
import script from "./salesDeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./salesDeleteConfirmation.vue?vue&type=script&lang=js"

import "./salesDeleteConfirmation.vue?vue&type=style&index=0&id=b703862c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b703862c"]])

export default __exports__